import { ChangeDetectorRef, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgIf } from '@angular/common';
import { FrontendConfig } from './core/interfaces/frontend-config';
import { ResourceService } from './core/services/resource.service';
import { ThemeService } from './core/services/theme.service';
import { throwError } from 'rxjs';
import { ConfigurationStore } from './core/stores/configuration.store';
import { ConfigService } from './core/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf]
})
export class AppComponent {
  isIframe = false;
  configuration: FrontendConfig;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon')!;
  illustrationPhoto: string;

  constructor(private resourceService: ResourceService,
    private cdr: ChangeDetectorRef,
    private themeService: ThemeService,
    private configurationStore: ConfigurationStore,
    private config: ConfigService) {
    this.illustrationPhoto = this.config.getSettings("msal.blobStorageIllustrationPhotos");
  }

  ngOnInit(): void {

    this.favIcon.href = this.illustrationPhoto + '/FavIcon.png';
    this.isIframe = window !== window.parent && !window.opener;
    this.getConfiguration();
  }

  private async injectDynamicManifest(config: FrontendConfig): Promise<void> {
    const iconBase = this.illustrationPhoto;
    const hasPwaIcons = localStorage.getItem('hasPwaIcons') === 'true';

    const icon192 = hasPwaIcons ? `${iconBase}/pwa-icon-192x192.png` : `${iconBase}/FavIcon.png`;
    const icon512 = hasPwaIcons ? `${iconBase}/pwa-icon-512x512.png` : `${iconBase}/FavIcon.png`;

    const manifest = {
      name: config.AppName || 'Portal',
      short_name: config.AppName || 'Portal',
      background_color: '#ffffff',
      theme_color: '#ffffff',
      display: 'standalone',
      start_url: window.location.origin + '/',
      scope: window.location.origin + '/',
      icons: [
        { src: icon192, sizes: '192x192', type: 'image/png', purpose: 'any' },
        { src: icon192, sizes: '192x192', type: 'image/png', purpose: 'maskable' },
        { src: icon512, sizes: '512x512', type: 'image/png', purpose: 'any' },
        { src: icon512, sizes: '512x512', type: 'image/png', purpose: 'maskable' }
      ]
    };
    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' });
    const manifestUrl = URL.createObjectURL(blob);
    let link: HTMLLinkElement | null = document.querySelector("link[rel='manifest']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    } else {
      if (link.href.startsWith('blob:')) {
        URL.revokeObjectURL(link.href);
      }
    }
    link.href = manifestUrl;
  }

  getConfiguration() {
    this.resourceService.getConfiguration<FrontendConfig>().subscribe({
      next: (response: FrontendConfig) => {
        this.configuration = response;
        this.configurationStore.config = response;
        this.injectDynamicManifest(response);
        if (this.configuration.ColorThemeModeString !== 'Dark') {
          this.themeService.setLightTheme();
        }
        else{
          this.themeService.setDarkTheme();
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        throwError(() => err);
      },
      complete: () => { }
    })
  }
}
